module.exports = {"500105001":"华新街街道","500105002":"江北城街道","500105003":"石马河街道","500105004":"大石坝街道","500105005":"寸滩街道","500105006":"观音桥街道","500105007":"五里店街道","500105008":"郭家沱街道","500105009":"铁山坪街道","500105100":"鱼嘴镇人民政府","500105101":"复盛镇人民政府","500105102":"五宝镇人民政府"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500105.json
// module id = 2039
// module chunks = 0